import React from 'react';
import { PersonIcon } from '@root/styles/icons';
import { Container } from './RoomCapacity.styles';
import useRoomCapacityText from '@common/hooks/useRoomCapacityText';

type RoomCapacityProps = {
  maxOccupancy?: number | null;
  maxAdults?: number | null;
  maxChildren?: number | null;
};

export const RoomCapacity: React.FC<RoomCapacityProps> = ({
  maxOccupancy,
  maxAdults,
  maxChildren,
}) => {
  const roomCapacityText = useRoomCapacityText({ maxAdults, maxChildren, maxOccupancy });

  return (
    <Container>
      <PersonIcon />
      {roomCapacityText}
    </Container>
  );
};
